import axios from 'axios';

const http = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    validateStatus: status => status >= 200 && status < 300,
});

http.defaults.timeout = 5000;
http.defaults.headers['X-Requested-With'] = 'XMLHttpRequest';

export default http;
